import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { LockedToolTipText } from "../../../components/tree/lockedToolTipText.js";
import { TreeStore } from "../../../store/treeStore.js";
function isStaticFolderSelected(selected, rootId) {
    if (!selected) {
        return true;
    }
    const { id } = selected;
    return id === TreeStore.ID_ALL || id == rootId || id === -2;
}
function useToolbarState(isWPAttachmentsSortMode, selected, rootId, attachmentFilterActive) {
    const restrictions = useMemo(()=>selected?.properties?.restrictions ?? [], [
        selected
    ]);
    const disableIfStatic = isStaticFolderSelected(selected, rootId);
    const lockedVisible = !!(selected && restrictions.length);
    const lockedToolTipText = lockedVisible ? /*#__PURE__*/ _jsx(LockedToolTipText, {
        restrictions: restrictions
    }) : "";
    const disableOrder = disableIfStatic || isWPAttachmentsSortMode || attachmentFilterActive || selected && selected.contentCustomOrder === 2 || selected && selected.orderAutomatically;
    return {
        lockedVisible,
        lockedToolTipText,
        orderDisabled: !!disableOrder,
        sortDisabled: disableIfStatic,
        renameDisabled: disableIfStatic || restrictions.indexOf("ren") > -1,
        trashDisabled: disableIfStatic || restrictions.indexOf("del") > -1,
        detailsDisabled: disableIfStatic
    };
}
export { useToolbarState };
